<template>
  <section class="feed">
    <div class="feed__wrapper">
      <div class="feed__body">

        <h2 class="feed__title" v-if="title">
          {{ title }} <span>{{ subtitle }}</span>
        </h2>

        <div class="feed__container" ref="scrollBody" :class="{ scroll: scroll }">
          <ul class="feed__list" v-if="feedData.length">
            <ThePostCard v-for="(post, index) in feedData" class="feed__card" :key="post" :data="post" :type="type"
              :link="routerLink" :menu="menu" @like="like(post)" @unlike="unlike(post)" @archive="archive(index)">
            </ThePostCard>

          </ul>

          <ul class="feed__list" v-else>
            <div class="feed__skeleton skeleton" v-for="n in 4" :key="n">
              <a-skeleton-image class="skeleton__img" />
            </div>
          </ul>
          <a-spin size="large" class="feed__loader" v-if="!theEnd && !oneLoad" />

        </div>

        <a-button type="dashed" class="feed__button" v-if="load">Load more</a-button>


      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, defineProps, watch, onMounted } from "vue";
import ThePostCard from "@/components/ui/ThePostCard.vue";
import { useStore } from "@/stores/store";
import { useRoute } from "vue-router"
import { useInfiniteScroll } from "@vueuse/core";

const store = useStore();
const route = useRoute()

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  subtitle: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "default",
  },
  fnData: {
    type: Function,
    default: () => []
  },
  load: {
    type: Boolean,
    default: false,
  },
  menu: {
    type: Boolean,
    default: false,
  },
  routerLink: {
    type: Boolean,
    default: false,
  },
  scroll: {
    type: Boolean,
    default: false,
  },
  route: {
    type: Boolean,
    default: false,
  },
  oneLoad: {
    type: Boolean,
    default: false,
  },
  filter: {
    type: Function,
    default: (list) => list
  }
});

const feedData = ref([])
let stateLoad = true
const theEnd = ref(false)
const scrollBody = ref()
let firstLoad = false

if (!props.oneLoad) {
  if (props.scroll) {
    useInfiniteScroll(
      scrollBody,
      async () => {
        if (!stateLoad && !theEnd.value && firstLoad) {
          await checkNext()
        }
      })
  } else {
    watch(() => store.scrollLoad, async () => {
      if (!stateLoad && !theEnd.value && firstLoad) {
        await checkNext()
      }
    })
  }
}

if (props.route) {
  watch(route, () => {
    setTimeout(async () => {
      theEnd.value = false;
      feedData.value = []
      await checkNext()
    }, 200);
  }, { deep: true })
}

async function checkNext() {
  try {
    stateLoad = true
    const nextPage = props.filter(await props.fnData(feedData.value.length))
    feedData.value.push(...nextPage)
    setTimeout(() => {
      stateLoad = false
      theEnd.value = nextPage.length == 12 ? false : true
      if (!firstLoad) {
        firstLoad = true
      }
    }, 1000);
  } catch (e) {
    console.error(e);
    feedData.value = []
  }
}

function like(post) {
  post.is_liked = true
  post.likes_count++
}

function unlike(post) {
  post.is_liked = false
  post.likes_count ? post.likes_count-- : '';
}

function archive(index) {
  feedData.value.splice(index, 1)
}

onMounted(async () => {
  await checkNext()
})


</script>

<style lang="scss" scoped>
.feed {
  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    width: 100%;
    color: $colorBlue;
    @include adaptiv-font(25, 18);
    @include adaptiv-line-height(28, 20);
    display: flex;
    align-items: flex-start;
    align-self: flex-start;
    @include adaptiv-value(column-gap, 10, 6, 1);
    @include adaptiv-value(margin-bottom, 10, 5, 1);

    span {
      color: #bfbfbf;
      font-size: 12px;
      @include adaptiv-font(12, 10);
      @include adaptiv-line-height(20, 16);
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    &.scroll {
      max-height: 630px;
      overflow: auto;
    }
  }

  &__list {
    width: 100%;
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(0, 300px));
    // grid-template-rows: repeat(auto-fit, minmax(300px, 1fr));

    grid-template-columns: repeat(4, 1fr);
    justify-content: center;
    @include adaptiv-value(gap, 15, 5, 1);
    @include scrollbars(12px, #bfbfbf, var(--ant-border), 10px);

    &::-webkit-scrollbar-thumb {
      border: 3px solid var(--ant-border);
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    &.scroll {
      max-height: 630px;
      overflow: auto;
    }

    @media (max-width: 1000px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__card {
    @include adaptiv-value(height, 250, 200, 1);
  }

  &__button {
    width: 100%;
    max-width: 323px;
    background: transparent;
    color: $colorBlue;
    border-color: $colorBlue;
    transition: all 0.3s ease 0s;

    &:active {
      color: #096dd9;
      border-color: #096dd9;
    }
  }

  &__loader {
    @include adaptiv-value(margin-top, 40, 20, 1);
  }

  & .skeleton {
    &__img {
      width: 100%;
    }
  }
}
</style>